module.exports = __webpack_public_path__ + "static/media/iso.08b5a41f.png";